import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWeatherStation } from 'features/weatherStations/hooks/useWeatherStation';
import { AlertEditingLayout } from 'components/layouts/AlertEditingLayout';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { WeatherStationAlertForm } from 'features/weatherStations/components/WeatherStationAlertForm';
import { useWeatherAlert } from 'features/weatherAlerts/hooks/useWeatherAlert';

export const WeatherStationEditAlert = (): JSX.Element => {
  const { stationId, alertId } = useParams<{
    stationId: string;
    alertId?: string;
  }>();
  const { t } = useTranslation();
  const location = useLocation<{ fromRoute?: string }>();
  const {
    weatherStation,
    isLoading: isLoadingStation,
    isError: isErrorForStation,
  } = useWeatherStation({
    id: parseInt(stationId, 10),
  });
  const {
    alert,
    isLoading: isLoadingAlert,
    isError: isErrorForAlert,
  } = useWeatherAlert({ alertId: alertId ? parseInt(alertId, 10) : undefined });

  const isLoading = isLoadingStation || isLoadingAlert;
  const isError = isErrorForStation || isErrorForAlert;

  const returnRoute =
    location.state?.fromRoute ||
    `/weather_station/${stationId}?tab=notifications`;

  const status = getPageStatus({
    isLoading,
    isError: isError || !weatherStation,
  });

  return (
    <PageLayout
      status={status}
      headerBarProps={{
        title: alertId
          ? t('waterLevel.alerts.editNotification')
          : t('waterLevel.alerts.addNotification'),
        action: returnRoute,
      }}
    >
      {weatherStation && (
        <AlertEditingLayout>
          <WeatherStationAlertForm
            weatherStation={weatherStation}
            alert={alert}
            fromRoute={returnRoute}
          />
        </AlertEditingLayout>
      )}
    </PageLayout>
  );
};
